import React from 'react';
import { Link } from 'react-router-dom';
import {withRouter} from "react-router-dom";
import AuthUserContext from '../Session/AuthUserContext';
import SignOutButton from '../SignOut';
import * as routes from '../../constants/routes';

import coursesNavImg from './courses-nav.svg';
import gigsNavImg from './gigs-nav.svg';

const Navigation = (props) =>
  <AuthUserContext.Consumer>
    {authUser => authUser
      ? <NavigationAuth />
      : null
    }
  </AuthUserContext.Consumer>

const NavigationAuth = () =>
  <div>
    <nav>
      <div className="navIcon">
        <Link className="link" to={routes.COURSES}>
          <img src={coursesNavImg} alt="Browse courses" />
        </Link>
      </div>
      <div className="navIcon">
        <Link className="link" to={routes.GIGS}>
          <img src={gigsNavImg} alt="Browse gigs" />
        </Link>
      </div>
    </nav>
  </div>

const NavigationNonAuth = () =>
  <div>
    <Link className="link" to={routes.LANDING}>Please sign up or log in to continue</Link>
  </div>



export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js